import { createContext, useContext } from 'react';

import { IOnePageViewProps } from './types';

const dataContext = createContext<IOnePageViewProps>({} as IOnePageViewProps);

export const DataContextProvider = dataContext.Provider;

export const useDataContext = () => useContext(dataContext);
